<template>
  <v-container>
    <!-- <v-btn round solid color="secondary" :to="{name: 'Practice'}">Back to Practice</v-btn> -->
    <v-layout>
      <v-flex>
        <!-- <v-btn @click="generateQuestion">New Question</v-btn> -->
        <h3>Identify the correct verb form.</h3>
        <v-flex mb-3 v-if="prompt">
          <li v-for="answer in prompt.answers">{{prompt ? answer : ""}}</li>
        </v-flex>
        <div v-if="prompt">
          <div>
            <v-btn-toggle v-if="!isLocked" column mandatory v-model="radioTense">
              <v-btn v-for="tense in tenses" :value="tense">{{tense}}</v-btn>
            </v-btn-toggle>
            <v-btn-toggle v-else v-model="radioTense">
              <div v-for="n in 1" :key="n">
                <div v-show="oneTense()" style="padding: 10px;">Tense: {{radioTense}}</div>
                <v-btn v-show="!oneTense()"
                v-for="tense in tenses" :key="tense" :value="tense">{{tense}}</v-btn>
              </div>
            </v-btn-toggle>
          </div>
          <br/>
          <div>
            <v-btn-toggle v-model="radioPerson">
              <v-btn v-for="person in persons" :value="person" key="person">{{person}}</v-btn>
            </v-btn-toggle>
          </div>
          <br/>
          <div>
            <v-btn-toggle v-model="radioNumber">
              <v-btn v-for="number in numbers" :value="number">{{number}}</v-btn>
            </v-btn-toggle>
          </div>
          <br/>
          <div>
            <v-btn-toggle v-model="radioForm">
              <v-btn v-for="form in forms" :value="form">{{form}}</v-btn>
            </v-btn-toggle>
          </div>
          <v-flex mb-3 mt-3>
            <h3 v-show="answered">{{correct ? "Correct" : "Incorrect"}}</h3>
            <h3 v-show="answered">Answers</h3>
            <div
              v-show="answered"
              v-for="form in matchingForms"
            >{{form[1]}}, {{form[2]}}, {{form[0]}}, {{form[3]}}</div>
          </v-flex>
          <span class="btn-bottom">
            <v-btn round outline color="primary" v-show="!answered" @click="handleSubmit">Check</v-btn>
            <v-btn round outline color="primary" @click="handleSkip" v-if="!answered">Skip</v-btn>
            <v-btn round outline color="primary" @click="handleSubmit" v-else>Next</v-btn>
          </span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  PARTS_OF_SPEECH,
  GENDER,
  VERB_TENSES,
  VERB_PERSON,
  VERB_NUMBER,
  VERB_CATEGORY,
  SAMPLE_VERBS,
} from "@/constants.js";
import {
  conjugate,
  generateStem,
  enumerateConjugations,
  getMatchingForms,
} from "@/conjugation.js";
import { db, auth } from '../../firebase/index.js'
import { randomConjugationPrompt } from "@/verbprompts.js";
import { VERB_FORMS, VERB_LESSON_MAP } from '../../constants';
export default {
  name: "ConjugationToParameters",
  props: {
    prompt: {
      type: Object,
      default: function(){ return randomConjugationPrompt(_.sample(SAMPLE_VERBS))},
    },
    controlled: {
      type: Boolean,
      default: false,
    },
    isLocked: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      sampleVerbs: SAMPLE_VERBS,
      categories: Object.values(VERB_CATEGORY),
      numbers: Object.values(VERB_NUMBER),
      persons: Object.values(VERB_PERSON),
      tenses: Object.values(VERB_TENSES),
      forms: Object.values(VERB_FORMS),
      answered: false,
      correctAnswer: "",
      correct: null,
      radioTense: "",
      radioNumber: "",
      radioPerson: "",
      radioForm: "",
    };
  },
  methods: {
    handleSubmit() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    checkAnswerSet(set) {
      for (let match of this.matchingForms) {
        var diff = _.difference(match, set);
        if (!diff.length) {
          return true;
        }
      }
      return false;
    },
    handleAnswer() {
      var ansSet = [
        this.radioTense,
        this.radioPerson,
        this.radioNumber,
        this.radioForm,
      ];
      this.correct = this.checkAnswerSet(ansSet);
      this.$emit("check", { correct: this.correct });
      this.answered = true;
    },
    handleSkip() {
      this.clear();
    },
    clear() {
      if (this.controlled) {
        this.$emit("next")
      }
      else{
        this.prompt = randomConjugationPrompt(_.sample(SAMPLE_VERBS))
      }
      this.radioTense = "";
      this.radioNumber = "";
      this.radioPerson = "";
      this.radioForm = "";
      this.answered = false;
    },
    lessonTense() {
        var entry = VERB_LESSON_MAP.find(
          e => e.lesson === this.$store.state.user.currentLesson
        );
        console.log("Verb Lesson Map Tense:" + entry.tense);
        return entry.tense;

        
    },
    oneTense() {
      if(this.lessonTense().length == 1){
        if(this.radioTense != this.lessonTense()[0]){
          this.radioTense = this.lessonTense()[0];
          console.log("tense: " + this.radioTense);
        }
        return true;
      }else{
        return false;
      }
    },
  },
  computed: {
    selectedVerbCategory() {
      var cat = this.sampleVerbs.find((x) => x.verb === this.prompt.verb);
      if (cat) return this.categories[cat.cat - 1];
      else return this.categories[0];
    },
    stem() {
      return generateStem(
        this.prompt.verb,
        this.prompt.category,
        this.prompt.tense
      );
    },
    matchingForms() {
      if (this.prompt) {
        return getMatchingForms(
          this.stem,
          this.prompt.answers,
          this.prompt.category,
          this.prompt.depForm
        );
      }
    },
  },
};
</script>

<style scoped>
incorrect {
  color: red;
}
/* .v-btn {
  margin: 5px 0px;
} */
.btn-bottom {
  position: absolute;
  bottom: 0;
  padding: 16px 0px;
}
</style>
